import { setConfirmRemoveMemberModal, setSelectedMemberDetail } from '../../../../../store/workspace/slice';
import { PlusIcon, LoadingIcon, UserTickIcon } from '../../../../../assets/icons';
import { useExtraServiceGate } from '../../hooks/useExtraServiceGate';
import { selectProfile } from '../../../../../store/workspace/selectors';
import { useDispatch, useSelector } from '../../../../../store/store';
import { MemberDetail } from '../../../../../store/workspace/types';
import styles from './style.module.scss';

/** Member seats of the organization. Only the account owner sees this. */
function AccountSeats() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const { inviteMember, addMoreMembers } = useExtraServiceGate();

    if (profile?.userRole !== 'owner') return null;

    const removeMember = (member: MemberDetail) => {
        dispatch(setSelectedMemberDetail(member));
        dispatch(setConfirmRemoveMemberModal(true));
    };

    return (
        <div className={styles.seats}>
            <div className={styles.seats_header}>
                <span className={styles.seats_header_title}>
                    Account Seats ({profile.invitations.length}/{profile.memberCounter})
                </span>
                <span
                    className={styles.seats_header_add}
                    onClick={addMoreMembers}
                >
                    Add More
                </span>
            </div>

            {profile.invitations?.map(member => <div
                key={member.email}
                className={styles.seats_member}
            >
                <div className={styles.seats_member_status}>
                    {member.status === 'pending' && <LoadingIcon />}
                    {member.status === 'accepted' && <UserTickIcon />}
                    <span>Member seat: {member.status}</span>
                </div>
                <div className={styles.seats_member_detail}>
                    <span className={styles.seats_member_detail_email}>{member.email}</span>
                    <span
                        className={styles.seats_member_detail_remove}
                        onClick={() => removeMember(member)}
                    >
                        Remove
                    </span>
                </div>
            </div>)}

            <div
                onClick={inviteMember}
                className={styles.seats_add}
            >
                <PlusIcon />
                <span>Add member seat</span>
            </div>
        </div>
    );
};

export default AccountSeats;
